// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/'
import axios from 'axios'
import clc from './components/common'

import Vuelidate from 'vuelidate'
import * as svgicon from 'vue-svgicon'
import './compiled-icons'
import Tooltip from 'vue-directive-tooltip'
import VueSession from 'vue-session'
import VuePaginate from 'vue-paginate'
import VueMq from 'vue-mq'
import VueTheMask from 'vue-the-mask'
import VueMeta from 'vue-meta'
import serviceInit from './service'
import * as registrationRouter from '@/router/registration'
import VueLazyload from 'vue-lazyload'
import store from './store'
import { format, parseISO } from 'date-fns'
import { fr as frLocale } from 'date-fns/locale'
import contenteditable from 'vue-contenteditable'
import VueCountryDropdown from 'vue-country-dropdown'

Vue.use(VueLazyload, {
  throttleWait: 0,
  preLoad: 2.5,
})
Vue.use(VuePaginate)
Vue.use(VueSession)
Vue.use(Vuelidate)
Vue.use(VueTheMask)
Vue.use(VueMeta)
Vue.config.productionTip = false
Vue.$http = Vue.prototype.$http = axios
Vue.use(svgicon, { tagName: 'svgicon' })
Vue.use(Tooltip)
Vue.use(VueMq, {
  breakpoints: {
    mobile: 767,
    tablet: 1023,
    desktop: Infinity,
  },
})
Vue.use(contenteditable)
Vue.use(VueCountryDropdown)

// Promise to load only once the user
let fetchDataUserPromise, user
// Promise to load only once the home pro
let fetchDataHomePromise; let fetchDataHomeID; const fetchDataHomePromises = []

/* Custom components */
Vue.component('logo-lien-header', clc.LogoLienHeader)
Vue.component('menu-base-sinscrire', clc.HeaderMenuSignup)
Vue.component('menu-base-se-connecter', clc.HeaderMenuSignin)
Vue.component('menu-base-aide', clc.HeaderMenuHelp)
Vue.component('select2', clc.Select2)
Vue.component('fc-slider', clc.FcSlider)
Vue.component('fc-slider-range', clc.FcSliderRange)
Vue.component('header-sign', clc.HeaderSign)
Vue.component('clc-footer', require('@/components/Footer').default)
Vue.component('menu-footer-cooloc', clc.FooterMenusCooloc)
Vue.component('menu-footer-a-propos', clc.FooterMenusAbout)
Vue.component('menu-footer-outils', clc.FooterMenusTools)
Vue.component('footer-applis', clc.FooterMenusApps)
Vue.component('footer-reseaux-sociaux', clc.FooterMenusSocials)
Vue.component('footer-moyen-paiement', clc.FooterMenusPayments)
Vue.component('menu-header-profil', clc.HeaderMenuProfile)
Vue.component('menu-header-signout', clc.HeaderMenuSignout)
Vue.component('menu-header-recherche', clc.HeaderMenuSearch)
Vue.component('menu-header-chat', clc.HeaderMenuChat)
Vue.component('menu-burger-mobile', clc.HeaderMenuBurgerMobile)
Vue.component('profile-picture', clc.ProfilePicture)
Vue.component('header-registration', clc.HeaderRegistration)
Vue.component('dashboard-sidebard', clc.DashboardSidebard)
Vue.component('header-user-info', clc.HeaderUserInfo)
Vue.component('header-user-info-registration', clc.HeaderUserInfoRegistration)
Vue.component('dashboard-newsletter', clc.DashboardNewsletter)
Vue.component('home-newsletter', clc.HomeNewsletter)
Vue.component('simple-popup', clc.SimplePopup)
Vue.component('payment-popup', clc.PaymentPopup)
Vue.component('vue-password', clc.VuePassword)
Vue.component('profile-card', clc.ProfileCard)
Vue.component('messages-header', clc.MessagesHeader)

export const eventBus = new Vue()

export const registrationHelpers = {
  profileProgress() {
    if ($('#progress-bar-profil').length) {
      const progress = $('#progress-bar-profil').attr('data-valeur-progress')
      let coulClass = ''
      if (progress > 85) {
        coulClass = 'coul-six'
      } else if (progress > 60) {
        coulClass = 'coul-cinq'
      } else if (progress > 40) {
        coulClass = 'coul-quatre'
      } else if (progress > 20) {
        coulClass = 'coul-trois'
      } else if (progress >= 10) {
        coulClass = 'coul-deux'
      } else {
        coulClass = 'coul-un'
      }
      $('#progress-bar-profil')[0].className = coulClass
      const longueurTimeline = $('#progress-bar-profil .container-bar').width()
      const progressPixels = ((longueurTimeline / 100) * progress) - 21
      const percent_number_step = $.animateNumber.numberStepFactories.append(' %')
      let vitesse = 2000
      if (progress == 10) {
        vitesse = 1000
      }
      $('#progress-bar-profil .container-bulle p span').animateNumber(
        {
          number: progress,
          easing: 'easeInQuad',
          numberStep: percent_number_step,
        },
        vitesse,
      )
      $('#progress-bar-profil .container-bulle p').animate(
        {
          left: progressPixels,
        },
        vitesse,
      )
      $('#progress-bar-profil .progress').animate(
        {
          width: progress + '%',
        }, vitesse,
      )
    }
  },
  matchingbarProgress(id, pos) {
    if ($('#matching-bar' + id + pos).length) {
      const progress = $('#matching-bar' + id + pos).data('valeur-matching')
      let coulClass = ''
      if (progress > 85) {
        coulClass = 'coul-six'
      } else if (progress > 60) {
        coulClass = 'coul-cinq'
      } else if (progress > 40) {
        coulClass = 'coul-quatre'
      } else if (progress > 20) {
        coulClass = 'coul-trois'
      } else if (progress >= 10) {
        coulClass = 'coul-deux'
      } else {
        coulClass = 'coul-un'
      }
      $('#matching-bar' + id + pos).addClass(coulClass)
      const longueurTimeline = $('#matching-bar' + id + pos + ' .container-bar').width()
      const progressPixels = ((longueurTimeline / 100) * progress) - 21
      const percent_number_step = $.animateNumber.numberStepFactories.append(' %')
      let vitesse = 2000
      if (progress == 10) {
        vitesse = 1000
      }
      $('#matching-bar' + id + pos + ' .container-pointer-chiffre span').animateNumber(
        {
          number: progress,
          easing: 'easeInQuad',
          numberStep: percent_number_step,
        },
        vitesse,
      )
      $('#matching-bar' + id + pos + ' .container-pointer-chiffre').animate(
        {
          left: progressPixels,
        },
        vitesse,
      )
      $('#matching-bar' + id + pos + ' .progress').animate(
        {
          width: progress + '%',
        }, vitesse,
      )
    }
  },
  resetDataUser() {
    fetchDataUserPromise = null
    fetchDataHomePromise = null
    eventBus.$emit('userChanged', null)
    eventBus.$emit('userReset', null)
  },
  resetDataHome() {
    fetchDataHomePromise = null
    eventBus.$emit('homeChanged', null)
    eventBus.$emit('homeReset', null)
  },
  fetchDataUser(vi, func = null, publicpage = false, forceUpdateEvent = false) {
    vi.error = user = null
    if (forceUpdateEvent) vi.user = null
    vi.loading = true

    if (!fetchDataUserPromise) {
      fetchDataUserPromise = vi.$http.get('/api/users/myself')
        .then(res => res.data)
    }
    return fetchDataUserPromise.then(
      u => {
        const userChanged = forceUpdateEvent ? true : u !== vi.user // (vi.user && (!user || vi.user.id !== user.id)) || (!vi.user && user)
        vi.user = user = u
        vi.loading = false

        // Unlogged
        if (!vi.user) {
          const currentUserJson = localStorage.getItem('currentUser')
          if (currentUserJson) {
            localStorage.removeItem('currentUser')
            const currentUser = JSON.parse(currentUserJson)
            if (currentUser === 'proprio') {
              document.cookie = 'hubspotutk=; Path=/; Domain=.cooloc.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
            }
          }

          if (publicpage) {
            eventBus.$emit('noUser', true)
          } else {
            vi.$router.push({
              name: 'NoAccess',
              query: {
                from: location.pathname,
              },
              params: vi.$route.query,
              hash: location.hash,
            })
          }
        } else {
          // Registration not complete
          if (!publicpage && registrationRouter.checkComplete(vi, user)) {
            fetchDataUserPromise = null
          }

          if (func != null) {
            func(vi)
          } else if (userChanged) {
            eventBus.$emit('userChanged', vi.user)
          }

          const currentUserJson = localStorage.getItem('currentUser')
          let currentUser = null
          if (currentUserJson) {
            currentUser = JSON.parse(currentUserJson)
            if (currentUser.id !== vi.user.id) {
              currentUser = null
            }
          }
          if (!currentUser) {
            currentUser = { id: vi.user.id, userType: this.userTypes.getType(vi.user) }
            localStorage.setItem('currentUser', JSON.stringify(currentUser))
            if (window.gtag) {
              if (vi.user && vi.user.id) {
                gtag('event', 'login', { userId: vi.user.id, userType: currentUser.userType })
              }
            }
            if (currentUser.userType === 'proprio' && window._hsq) {
              window._hsq.push(['identify', {
                email: vi.user.email,
                id: vi.user.id,
                fullName: vi.user.first_name + ' ' + vi.user.name,
                firstName: vi.user.first_name,
                lastName: vi.user.name,
              }])
            }
          }
        }
      },
      err => {
        // On error
        if (publicpage) {
          eventBus.$emit('noAuthorized')
        } else {
          vi.error = err
          if (err.response.status === 401) {
            vi.$router.push({
              name: 'NoAccess',
              query: {
                from: location.pathname,
              },
              params: vi.$route.query,
              hash: location.hash,
            })
          }
        }
      },
    )
  },
  goToPage(vue, model, direction) {
    return registrationRouter.goToPage(vue, model, direction)
  },
  routeOrder(user) {
    return registrationRouter.routeOrder(user)
  },
  userTypes: registrationRouter.userTypes,
  setTitle: registrationRouter.setTitle,
  pathToFilename: registrationRouter.pathToFilename,
  getAge(dateString) {
    const today = new Date()
    const birthDate = new Date(dateString)
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  },
  show(vi, content, specificId = null) {
    if ('title' in content && 'text' in content && vi.popupInfo) {
      vi.popupInfo.title = content.title
      vi.popupInfo.link = content.title
      vi.popupInfo.linktitle = content.title
      vi.popupInfo.content = "<div class='scroller'><p>" + content.text + "</p></div><div class='actions'><button class='white-button mfp-close'>OK</button></div>"
      if (specificId == null) {
        $.magnificPopup.open({ items: { src: '#popup-info' } })
      } else {
        $.magnificPopup.open({ items: { src: '#' + specificId } })
      }
    } else if (vi.popupError) {
      vi.popupError.title = 'Error ' + content.response.status
      vi.popupError.link = 'Error ' + content.response.status
      vi.popupError.linktitle = 'Error ' + content.response.status
      vi.popupError.content = "<div class='scroller'><p>" + content.response.statusText + '</p></div>'
      if (specificId == null) {
        $.magnificPopup.open({ items: { src: '#popup-error' } })
      } else {
        $.magnificPopup.open({ items: { src: '#' + specificId } })
      }
    }
  },
  sortedArrayAsc: function (items, key) {
    function compare(a, b) {
      if (a[key] < b[key]) { return -1 }
      if (a[key] > b[key]) { return 1 }
      return 0
    }
    return items.sort(compare)
  },
  sortedArrayDesc: function (items, key) {
    function compare(a, b) {
      if (b[key] < a[key]) { return -1 }
      if (b[key] > a[key]) { return 1 }
      return 0
    }
    return items.sort(compare)
  },
  contentPopup() {
    if ($('.magic-popup').length) {
      $.extend(true, $.magnificPopup.defaults, {
        tClose: 'Fermer (Esc)',
        tLoading: 'Chargement...',
        gallery: {
          tPrev: 'Precédent (Touche flèche gauche)',
          tNext: 'Suivant (Touche flèche droite)',
          tCounter: '%curr% / %total%',
        },
        image: {
          tError: '<a href="%url%">L\'image</a> n\'a pu être chargée.', // Error message when image could not be loaded
        },
        ajax: {
          tError: '<a href="%url%">Le contenu</a> ne peut-être chargé.<br><a href="%url%">Cliquez-ici</a>', // Error message when ajax request failed
        },
      })
      const hauteurFenetre = document.documentElement.clientHeight
      const hauteurPopup = hauteurFenetre - 40
      $('.popup-ajax a').magnificPopup({
        type: 'ajax',
        prependTo: $('#vue-app'),
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        mainClass: 'mfp-fade',
        callbacks: {
          ajaxContentAdded: function () {
            const hauteurTitre = $('.container-content-popup h1').height()
            const hauteurContainerTexte = (hauteurPopup - hauteurTitre) - 98// padding container + margin-bottom;
            $('.container-content-popup > div').scrollbar({
              showArrows: true,
              scrolly: 'advanced',
            })
            $('.container-content-popup > div').css('height', hauteurContainerTexte)
            $('.container-content-popup').css('height', hauteurPopup)
            console.log('content added')
          },
          resize: function () {
            const hauteurFenetre = document.documentElement.clientHeight
            const hauteurPopup = hauteurFenetre - 40
            const hauteurTitre = $('.container-content-popup h1').height()
            const hauteurContainerTexte = (hauteurPopup - hauteurTitre) - 98// padding container + padding-bottom;

            $('.container-content-popup > div').css('height', hauteurContainerTexte)
            $('.container-content-popup').css('height', hauteurPopup)
          },
        },
      })
      $('.popup-fiche-detail').magnificPopup({
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        mainClass: 'mfp-fade',
        gallery: {
          enabled: true,
        },
        callbacks: {
          open: function () {
            const mfp = jQuery.magnificPopup.instance
            console.log(mfp)

            // hide image nav when first/last
            if (mfp.index >= mfp.items.length - 1) {
              $('.mfp-container').addClass('mfp-last')
            } else {
              $('.mfp-last').removeClass('mfp-last')
            }
            if (mfp.index == 0) {
              $('.mfp-container').addClass('mfp-first')
            } else {
              $('.mfp-first').removeClass('mfp-first')
            }
          }, // open

          change: function () {
            const mfp = jQuery.magnificPopup.instance

            // hide image nav when first/last
            if (mfp.index >= mfp.items.length - 1) {
              $('.mfp-container').addClass('mfp-last')
            } else {
              $('.mfp-last').removeClass('mfp-last')
            }
            if (mfp.index == 0) {
              $('.mfp-container').addClass('mfp-first')
            } else {
              $('.mfp-first').removeClass('mfp-first')
            }
          }, // change
          resize: function () {
            const hauteurFenetre = document.documentElement.clientHeight
            // TODO à revoir avec un each pour hauteur header différente suivant les fiches -> cf. un peu plus bas
            const hauteurPopupInline = hauteurFenetre - 148
            const hauteurContainerScrollbar = (hauteurPopupInline - 164) - 52
            $('.popup-detail').css('height', hauteurPopupInline)
            $('.popup-detail').children('.scrollbar-cooloc').css('height', hauteurContainerScrollbar)
          },
        },
      })
    }
  },
}

/**
 * Load the home once
 * @param {Vue} vue Vue instance or component
 * @param {string} home_id
 * @param {boolean} reload
 */
export const fetchDataHome = (vue, home_id, reload) => {
  if (!fetchDataHomePromise || fetchDataHomeID !== home_id || reload) {
    fetchDataHomeID = home_id
    const promise = new Promise((resolve, reject) => {
      fetchDataHomePromises.push([resolve, reject])
    })
    fetchDataHomePromise = vue.$http.get(`/api/homes/${home_id}`)
      .then(res => {
        if (home_id === fetchDataHomeID) {
          res.data.$from_cache = false
          for (const array of fetchDataHomePromises) {
            array[0](res.data)
          }
          eventBus.$emit('homeChanged', res.data)
          res.data.$from_cache = true
        }
        return res.data
      })
      .catch(err => {
        if (home_id === 'default' && err.response.status === 404) {
          for (const array of fetchDataHomePromises) {
            array[0](null)
          }
          eventBus.$emit('homeChanged', null)
        }
        if (home_id === fetchDataHomeID) {
          for (const array of fetchDataHomePromises) {
            array[1](err)
          }
        }
      })
    return promise
  }
  return fetchDataHomePromise
}

/**
 * Return the current valid subscription
 * @param {Object} user User object from api
 * @returns {Object}  subscription object, or null
 */
export const currentSubscription = user => {
  if (!user || !user.subscriptions || !user.subscriptions.length) return null

  const now = new Date()
  let min = 0
  let res = null
  for (const sub of user.subscriptions) {
    const date = new Date(sub.valid_until)
    if (date > now && (min === 0 || date < min)) {
      min = date
      res = sub
    }
  }
  return res
}

/**
 * Returns true if the user has a valid subscription
 * @param {Object} user User object from api
 * @returns {boolean}
 */
export const hasSubscription = user => {
  // return currentSubscription(user) !== null
  return true
}

/**
 * Return the last subscription by valid_until date
 * @param {Object} user User object from api
 * @returns {Object}  subscription object, or null
 */
export const lastSubscription = (user) => {
  if (!user || !user.subscriptions || !user.subscriptions.length) return null

  const now = new Date()
  let max = 0
  let res = null
  for (const sub of user.subscriptions) {
    const date = new Date(sub.valid_until)
    if (date > now && date > max) {
      max = date
      res = sub
    }
  }
  return res
}

/**
 * Vue filter to round the decimal to the given place.
 * http://jsfiddle.net/bryan_k/3ova17y9/
 *
 * @param {String} value    The value string.
 * @param {Number} decimals The number of decimal places.
 */
Vue.filter('round', function (value, decimals) {
  if (!value) {
    value = 0
  }

  if (!decimals) {
    decimals = 0
  }

  value = value.toFixed(decimals)// Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  return value
})

/**
 * Vue filter to get first character of a string
 *
 * @param {String} value    The value string.
 */
Vue.filter('initial', function (value) {
  return value.substring(0, 1)
})

/**
 * Vue filter to format numbers over 999
 *
 * @param {Number} value    The value number.
 */
Vue.filter('thousands', (value) => {
  return (value).toLocaleString('fr')
})

/**
 * Vue filter to format dates
 *
 * @param {Number} value    The value date.
 * @param {format} format   format pattern
 */
Vue.filter('formatDate', function (value, fmt) {
  if (value instanceof Date) {
    return format(value, fmt, { locale: frLocale })
  }
  return format(parseISO(value), fmt, { locale: frLocale })
})
Vue.filter('formatDateLocale', function (date) {
  if (!date) return ''
  if (date instanceof Date) {
    return date.toLocaleDateString('fr-FR')
  }
  return new Date(date).toLocaleDateString('fr-FR')
})

/**
 * Vue filter to format prices
 *
 * @param {Number} value    The value number.
 */
Vue.filter('money', (value, precision) => {
  const valint = value * 1
  if (isNaN(valint)) {
    if (typeof value === 'string') return value
    return '-,--\u00a0€'
  }
  if (!precision && precision !== 0) precision = 2
  if (window.Intl && Intl.NumberFormat) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: precision }).format(valint)
  }
  return valint.toFixed(precision).replace('.', ',') + '\u00a0€'
})

Vue.filter('titleCase', function (str) {
  const capitalized = []
  str.split(' ').forEach(word => {
    capitalized.push(
      word.charAt(0).toUpperCase() +
      word.slice(1).toLowerCase(),
    )
  })
  return capitalized.join(' ')
})

/**
 * Vue filter to capitalize a string
 *
 * @param {String} value    The value string.
 */
function capitalize(value) {
  value = value + ''
  return value.charAt(0).toUpperCase() + value.substring(1)
}
Vue.filter('capitalize', capitalize)

/**
 * Vue filter to format room names
 * @param {Object} room    Room object with { name, number }.
 */
Vue.filter('roomName', (room, prefix = '') => {
  return capitalize(room.name) || (prefix + String.fromCharCode(65 + room.number))
})

function setCanonical(url) {
  const current = document.querySelector('head link[rel="canonical"]')
  if (current) {
    if (url) {
      current.setAttribute('href', url)
    } else {
      current.parentNode.removeChild(current)
    }
  } else if (url) {
    const link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    link.setAttribute('href', url)
    document.getElementsByTagName('head')[0].appendChild(link)
  }
}

// Access chrome console in templates with $console
Object.defineProperty(Vue.prototype, '$console', {
  get() { return console },
})

// Before routing
router.beforeEach((to, from, next) => {
  // Pages' title / canonical
  if (to.meta) {
    setCanonical(to.meta.canonical)
  }

  Promise.resolve().then(() => {
    if (to.meta && typeof to.meta.title === 'string') {
      return to.meta.title
    }
    if (to.meta && typeof to.meta.title === 'function') {
      return to.meta.title(to, from)
    }
    return 'Colocataire, colocation, logement contre services | COOLOC'
  }).then(title => {
    document.title = title
  })

  const routeWithDescription = to.matched.slice().reverse().find(r => r.meta && r.meta.description)
  if (routeWithDescription && routeWithDescription.meta) {
    const element = document.querySelector("meta[name='description']")
    if (element) {
      element.setAttribute('content', routeWithDescription.meta.description)
    }
  }

  const routeWithKeywords = to.matched.slice().reverse().find(r => r.meta && r.meta.keywords)
  if (routeWithKeywords && routeWithKeywords.meta) {
    const element = document.querySelector("meta[name='keywords']")
    if (element) {
      element.setAttribute('content', routeWithKeywords.meta.keywords)
    }
  }

  next()

  // Scroll to top on every page
  if (to.path !== from.path) {
    $('html, body').animate({
      scrollTop: 0,
    }, 200)
  }
})

router.afterEach((to, from) => {
  // Analytics
  try {
    if (window.gtag) {
      gtag('event', 'page_view', {
        pageTitle: document.title,
        pageLocation: to.path,
      })
    }
  } catch (er) {}
})

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
})

// Override url resolve
const old_router_resolve = router.resolve
router.resolve = function (location, current) {
  // Dashboard page
  if (typeof location === 'object' && location.name && location.name.substring(0, 9) === 'Dashboard') {
    // Fill user_type param
    if (!location.params) location.params = {}
    if (!location.params.user_type) {
      // Curent user type
      if (current && current.params && current.params.user_type) {
        location.params.user_type = current.params.user_type
      } else if (user) {
        // From user object
        location.params.user_type = registrationRouter.userTypes.baseURL(user)
      } else {
        // Default to user
        location.params.user_type = 'users'
      }
    }

    // Keep home_id
    if (current && current.query && current.query.home_id) {
      if (!location.query) location.query = {}
      if (!location.query.home_id) location.query.home_id = current.query.home_id
    }

    // Keep search
    if (current && current.query && current.query.search && (current.name || '').substring(0, 9) !== 'Dashboard') {
      if (!location.query) location.query = {}
      if (!location.query.search) location.query.search = current.query.search
    }
  }
  return old_router_resolve.apply(this, arguments)
}

// Override router push
const old_router_push = router.push
router.push = function (location) {
  const current = router.currentRoute

  // Dashboard page
  if (typeof current === 'object' && typeof location === 'object' && (location.name || current.name || '').substring(0, 9) === 'Dashboard') {
    // Keep home_id
    if (current.query && current.query.home_id) {
      if (!location.query) location.query = {}
      if (!location.query.home_id) location.query.home_id = current.query.home_id
    }
  }

  // Keep search
  if (current && current.query && current.query.search && typeof location === 'object' && (current.name || '').substring(0, 9) !== 'Dashboard') {
    if (!location.query) location.query = {}
    if (!location.query.search) location.query.search = current.query.search
  }

  return old_router_push.apply(this, arguments)
}

axios.interceptors.response.use(null, error => {
  if (error.response && error.response.status === 424 && error.response.data.error &&
		error.response.data.error.indexOf(' not found ') > 0 &&
		router.currentRoute.fullPath !== '/' &&
		router.currentRoute.name !== 'DashboardHomeMatching' &&
		router.currentRoute.name !== 'DashboardUserMatching'
  ) {
    router.push('/')
  }
  return Promise.reject(error)
})

// Init service worker
serviceInit(vue)

// Handle PWA install prompt for Android/Chrome
let deferredPrompt = null
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault()
  // Stash the event so it can be triggered later
  deferredPrompt = e
  console.log('PWA install prompt ready')

  // Notify the app that install is available
  eventBus.$emit('pwaInstallAvailable', true)
})

window.addEventListener('appinstalled', () => {
  console.log('PWA was installed')
  deferredPrompt = null
  eventBus.$emit('pwaInstalled', true)
})

// Export function to trigger install prompt
export const showInstallPrompt = () => {
  if (!deferredPrompt) {
    console.warn('Install prompt not available')
    return Promise.resolve(false)
  }

  deferredPrompt.prompt()
  return deferredPrompt.userChoice
    .then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt')
        return true
      } else {
        console.log('User dismissed the install prompt')
        return false
      }
    })
    .finally(() => {
      deferredPrompt = null
    })
}

// Check if app is already installed
export const isPWAInstalled = () => {
  // Check if running in standalone mode (installed PWA)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true
  }
  // Check iOS standalone mode
  if (window.navigator.standalone === true) {
    return true
  }
  return false
}
